import { render, staticRenderFns } from "./Action.vue?vue&type=template&id=f83c6f34&scoped=true&"
import script from "./Action.vue?vue&type=script&lang=js&"
export * from "./Action.vue?vue&type=script&lang=js&"
import style0 from "./Action.vue?vue&type=style&index=0&id=f83c6f34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f83c6f34",
  null
  
)

export default component.exports